import Component from './van-list'

export default Component